import api from '@/api';
import { API_BASE_URL } from '../../index';
import { VehiclesWithoutMovementRequest } from './vehicleWithoutMovements.types';

const CONTROLLER_URL = `${API_BASE_URL}/generate/vehicles-without-movements`;

export async function getReportVehiclesWithoutMovement(
  params: VehiclesWithoutMovementRequest,
) {
  const result = (await api.getReport(CONTROLLER_URL, params)) as unknown;

  return result as BlobPart;
}
